































































import {Vue, Component, Prop} from 'vue-property-decorator'
import {TodoDataServicesCollection} from '@/accessors/TodoDataServicesCollection';
import QInput, {Loading} from 'quasar';
import ITodoCollection, {ITodo} from '@/models/todoCollection';
import { mapGetters } from "vuex";
import firebase from 'firebase';
import "../registerServiceWorker";
import DocumentModule from '@/store/application/DocumentModule';
import HomeViewModule from '@/store/view/HomeViewModule';

@Component
export default class ToDo extends Vue {
	public adminId = process.env.VUE_APP_FIREBASE_ADMIN;
	public taskComplete: string[] = [];
	public selected: string[] = [];
	public readonly columns = [
		{
			name: 'title',
			label: 'Title',
			align: 'left',
			field: (row: any) => row.title,
			sortable: true,
		},
		{
			name: 'body',
			label: 'Body',
			align: 'left',
			field: (row: any) => row.body,
			sortable: true,
		}
	]
	public pagination = {
		sortBy: 'title',
        descending: false,
        page: 1,
        rowsPerPage: 10,
	}

	public get tasks(): ITodo[] {
		return DocumentModule.tasks;
	}
	
	public get document(): ITodoCollection {
		return DocumentModule.document;
	}

	public get user() {
		return this.$store.getters.user;
	}

	public allowAddRecord(document: ITodoCollection): boolean {
		if ((this.user.data ? this.user.data.uid : '' ) === (document.userId || process.env.VUE_APP_FIREBASE_ADMIN)) {
			return true;
		} else {
			return false;
		}
	}

	public getSelectedString() {
		return this.selected.length === 0 ? '' : `${this.selected.length} record${this.selected.length > 1 ? 's' : ''} selected of ${this.tasks.length}`
	}
	
	public saveTaskTitle(document: ITodoCollection, task: ITodo, title: string ) {
		let todoDataService = new TodoDataServicesCollection();
		let newDocument: ITodoCollection = {
			id: this.document.id,
			subject: this.document.subject,
			credit: this.document.credit,
			description: this.document.description,
			topic: this.document.topic,
			todos: this.document.todos.map((todo: ITodo) => {
				if (todo.id === task.id) {
					return {
						id: task.id,
						title: title,
						body: task.body,
					}
				} else {
					return todo;
				}
			}),
			userId: this.document.userId,
		}
		let context = this;
		if ((this.user.data ? this.user.data.uid : '' ) === (document.userId || process.env.VUE_APP_FIREBASE_ADMIN)) {
			console.log(this.user.data)
			console.log(document.userId)
			console.log(process.env.VUE_APP_FIREBASE_ADMIN)
			todoDataService.Update(newDocument, this.$route.params.id).then(function () {
			context.loadData();
			})
		}

	}

	public saveTaskBody(document: ITodoCollection, task: ITodo, body: string ) {
		let todoDataService = new TodoDataServicesCollection();
		let newDocument: ITodoCollection = {
			id: this.document.id,
			subject: this.document.subject,
			credit: this.document.credit,
			description: this.document.description,
			topic: this.document.topic,
			todos: this.document.todos.map((todo: ITodo) => {
				if (todo.id === task.id) {
					return {
						id: task.id,
						title: task.title,
						body: body,
					}
				} else {
					return todo;
				}
			}),
			userId: this.document.userId,
		}
		let context = this;
		if ((this.user.data ? this.user.data.uid : '' ) === (document.userId || process.env.VUE_APP_FIREBASE_ADMIN)) {
			todoDataService.Update(newDocument, this.$route.params.id).then(function () {
			context.loadData();
			})
		}

	}

	public addRecord(document: ITodoCollection) {
		let todoDataService = new TodoDataServicesCollection();
		let newDocument: ITodoCollection = {
			id: this.document.id,
			subject: this.document.subject,
			credit: this.document.credit,
			description: this.document.description,
			topic: this.document.topic,
			todos: [...this.document.todos, {id: this.todoIdGenerator(), title:'', body:''}],
			userId: this.document.userId,
		}
		let context = this;
		if ((this.user.data ? this.user.data.uid : '' ) === (document.userId || process.env.VUE_APP_FIREBASE_ADMIN)) {
			todoDataService.Update(newDocument, this.$route.params.id).then(function () {
			context.loadData();
			})
		}
	}

	public deleteTodo(document: ITodoCollection, task: ITodo) {
		let todoDataService = new TodoDataServicesCollection();
		let context = this;
		if ((this.user.data ? this.user.data.uid : '' ) === (document.userId || process.env.VUE_APP_FIREBASE_ADMIN)) {
			todoDataService.DeleteTodoField(document.id, task).then(function () {
			context.loadData();
			})
		}
	}

	public todoIdGenerator(): string {
		let exists: boolean = false;
		let newId: string = '';
		do {
			newId = (Math.floor(Math.random() * 1000000) + 1000000).toString();
			this.document.todos.map((todo: ITodo) => {
				if (todo.id === newId) {
					exists = true;
				}
			});
		} while (exists);
		return newId;
	}

	public async loadData() {
		await DocumentModule.loadDocument(this.$route.params.id);
	}

	beforeCreate() {
        firebase.auth().onAuthStateChanged(async () => {
			Loading.show();
            await HomeViewModule.loadDocuments(this.$store.getters.user);
			await DocumentModule.loadDocument(this.$route.params.id);
			Loading.hide();
        })
    }

}

